import { User } from '@weblite/ts-action/user'
import {
  getRange,
  getLastMentionCharIndexBeforeCaret,
  putCaretAtEndOfEditor,
} from './utils'
import { removeSelectedContent } from './remove'
import { convertFormattedTextToHtml } from './convert'
import { createMentionLinkNode } from './create'
import { getUserDisplayName } from '$logic/users'

export function insertMentionIntoEditor(
  editorElement: HTMLDivElement,
  user: User,
) {
  const { id: userId, username } = user

  const range = getRange()
  if (!range) return

  if (username) {
    const containerNode = range.commonAncestorContainer
    const mentionCharIndex = getLastMentionCharIndexBeforeCaret()
    if (mentionCharIndex < 0) return

    containerNode.nodeValue = [
      containerNode.nodeValue?.slice(0, mentionCharIndex),
      `@${username} `,
      containerNode.nodeValue?.slice(range.startOffset),
    ].join('')

    editorElement.focus()
    range.setStart(containerNode, mentionCharIndex + username.length + 2)
    return
  }

  const mentionCharIndex = getLastMentionCharIndexBeforeCaret()
  if (mentionCharIndex < 0) return

  const containerNodeValue = range.commonAncestorContainer.nodeValue
  range.commonAncestorContainer.nodeValue =
    containerNodeValue?.slice(0, mentionCharIndex) ||
    '' + containerNodeValue?.slice(range.startOffset) ||
    ''

  range.setStart(range.commonAncestorContainer, mentionCharIndex)
  range.collapse(true)

  const mentionNode = createMentionLinkNode(getUserDisplayName(user), userId)
  range.insertNode(mentionNode)

  range.setStartAfter(mentionNode)
  range.insertNode(document.createTextNode(' '))
  range.collapse()

  editorElement.focus()
}

export function insertContent(editorElement: HTMLDivElement, content: string) {
  if (!content?.trim()) return
  let range = getRange()

  // Put range at end if not exists!
  if (!range) putCaretAtEndOfEditor(editorElement)
  if (!range.collapsed) removeSelectedContent(editorElement)
  range = getRange()

  const contentToInsert = convertFormattedTextToHtml(content)
  range?.insertNode(contentToInsert)
  range?.collapse()
}
